import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./services.css";
const Services = () => {
  useEffect(() => {
    const cards = document.querySelectorAll(".animate-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);
  const services = [
    {
      title: "Legal Advocacy",
      desc: "Promoting justice through strong legal representation and advocacy initiatives.",
      icon: "⚖️",
    },
    {
      title: "Education & Training",
      desc: "Workshops, seminars, and capacity building for legal professionals.",
      icon: "🎓",
    },
    {
      title: "Legal Aid & Social Justice",
      desc: "Providing access to justice for underprivileged communities.",
      icon: "🤝",
    },
    {
      title: "Policy & Research",
      desc: "Research-driven policy recommendations and legal reforms.",
      icon: "📘",
    },
    {
      title: "Youth Initiatives",
      desc: "Engaging youth in legal awareness and leadership programs.",
      icon: "👥",
    },
    {
      title: "Public Awareness",
      desc: "Campaigns to educate citizens about rights and responsibilities.",
      icon: "📢",
    },
  ];

  return (
    <>
      {/* Banner */}
      <div
        className="blue-band d-flex align-items-center bg-dark"
        style={{ height: "300px" }}
      >
        <Container>
          <h1 className="display-4 text-white">Our Services</h1>
          <p className="lead text-white">
            Empowering justice through action, education, and advocacy
          </p>
        </Container>
      </div>

      {/* Services Section */}
      <Container className="py-5">
        <Row>
          {services.map((service, index) => (
            <Col md={4} className="mb-4" key={index}>
              <Card className="service-card text-center p-4 animate-card">
                <div className="service-icon">{service.icon}</div>
                <Card.Body>
                  <Card.Title className="mt-3">{service.title}</Card.Title>
                  <Card.Text>{service.desc}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Call To Action */}
      <div className="section-bg py-5 text-center">
        <Container>
          <h2>Need Our Support?</h2>
          <p>
            Join us or reach out to collaborate and make a meaningful impact.
          </p>
          <Button className="gold-btn mt-2">Contact Us</Button>
        </Container>
      </div>
    </>
  );
};

export default Services;
